<template>
	<div class="title">
		<div class="title-l">
			<span class="title-line"></span>
			<h3>{{title}}</h3>
		</div>
		<div class="title-r">
			<slot name="title-more"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TitleAdmin',
		props: {
			title: {
				type: String,
				value: ''
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.title{
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
		padding-bottom: 10px;
		border-bottom: 1px solid hsla(0,0,59%,.1);
		box-sizing: border-box;
		.title-l{
			display: flex;
			align-items: center;
			.title-line{
				width: 4px;
				height: 20px;
				background: #f55;
				display: block;
				margin-top: 4px
			}
			h3{
				padding-left: 10px;
				line-height: 28px;
				font-size: 16px;
				color: #3b3b3b;
				letter-spacing: 1.43px;
				font-weight: 500;
			}
		}
	}
</style>
